import { JoinSessionButtonWrapper } from '../admission/JoinSessionButton';

export function JoinSessionCta() {
  return (
    <div className='flex flex-col gap-4 mt-4'>
      <JoinSessionButtonWrapper />
    </div>
  );
}
